import React from "react";
import AddTransporteForm from "./AddTransporteForm";

const AddTransporte = ({ show, setShow }) => {
  const handleShow = () => {
    setShow(!show);
  };
  return (
    <>
      <div className="">
        <button className="btn btn-dark" onClick={handleShow}>
          {show ? "Ocultar Form" : "Agregar Transporte"}
        </button>
      </div>
      {show && (
        <div className="mt-2">
          <AddTransporteForm setShow={setShow} />
        </div>
      )}
    </>
  );
};
export default AddTransporte;
